import styled from "styled-components/macro";

import UserPledgesList from "CrossFeatureComponents/UserPledgesList/UserPledgesList";
import { useUserPledgesList } from "CrossFeatureComponents/UserPledgesList/UserPledgesListContext";
import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import FnrIcon from "UI/FnrIcon";

import ListIsEmpty from "./ListIsEmpty";

export default function PledgesScreen() {
  const {
    state: { userID, pledgeableCampaigns = [] },
  } = useManageMyGivingPage();
  const { state: pledgesState } = useUserPledgesList();

  const pledges = pledgesState?.pledges || [];
  const activePledges = pledges.filter((p) => p.status === "active") || [];
  const doneFetching = pledgesState?.fetchPledgesStatus === "success";
  const campaign = pledgeableCampaigns[0];
  const showSetupPledgeContent =
    doneFetching && campaign?.ID && activePledges.length === 0;

  return (
    <Wrapper>
      {showSetupPledgeContent ? (
        <ListIsEmpty
          title="Your household has not created a pledge yet. We humbly invite you to support our mission by creating a pledge."
          icon={<FnrIcon fad fa-handshake />}
          showButton={Boolean(campaign.ID)}
          linkTo={`/pledge/${campaign.ID}`}
          buttonText={`Make a pledge to ${campaign.title} now`}
          messageIfNoButton="Currently no campaigns are set up to allow pledges."
        />
      ) : null}

      <ListWrapper style={{ marginTop: showSetupPledgeContent ? "-28px" : 0 }}>
        <UserPledgesList userID={userID} />
      </ListWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  padding: 0 20px 20px 20px;

  --pledgesTextColor: #efefef;
  --pledgesProgressBarBorder: #efefef;
  --pledgesProgressBarBackground: rgba(255, 255, 255, 0.1);
`;

const ListWrapper = styled.div`
  margin-left: -30px;
  margin-right: -30px;
`;
